<template>
  <v-card class="mx-auto blue-border" max-width="500" raised :elevation="1">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-subtitle class="insight-title">Total {{ title }}</v-list-item-subtitle>
        <v-list-item-subtitle class="insight-value">
          <b>{{ count }}</b>
        </v-list-item-subtitle>
      </v-list-item-content>

      <!-- <v-list-item-avatar size="55" class="ml-0 mr-3 insight-avatar"></v-list-item-avatar> -->
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    count: Number,
  },
};
</script>

<style scoped>
.blue-border {
  border-top: 3.5px solid #6490f1;
}

.insight-title {
  text-transform: capitalize;
  font-size: 1.1rem;
}

.insight-value {
  font-size: 1.3rem;
}

.insight-avatar {
  background-color: #bdbdbd;
}

.insight-icon {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 20px;
  left: 10px;
}
</style>